module.exports = __webpack_public_path__ + "static/img/car_exception.9.4b30f1b0.png";